// extracted by mini-css-extract-plugin
export default {"leftBar":"Popup_leftBar__B0jcK","login":"Popup_login__l1oq3","loginLeft":"Popup_loginLeft__UA10v","tabnav":"Popup_tabnav__a7oJN"};